require('ta-semantic-ui/semantic/dist/components/reset.css');
require('ta-semantic-ui/semantic/dist/components/site.css');
require('styles/App.css');

import React from 'react';
import SVGQuarterMap from '../svgQuarterMap/SVGMap.component';
import ContainerDimensions from 'react-container-dimensions';
import zhQuarterMap from '../svgQuarterMap/data/zhQuarterMap.svg';
import zhQuarterMapData from 'json!../svgQuarterMap/data/zhQuarterMapBodenpreise.json';
// import zhCircleMapData from 'json!../svgQuarterMap/data/zhCircleMap.json';

class AppComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showQuarterList: false,
      readerIsCityCitizen: false,
      readerMadeHisChoice: false,
      chosenQuarter: '',
      showOverlay: false,
      dataSource: [
        {day:'02-11-1999',title:'Kreis 1',count:500},
        {day:'02-12-2000',title:'Kreis 2',count:250},
        {day:'02-13-2001',title:'Kreis 3',count:50},
        {day:'02-14-2002',title:'Kreis 4',count:500},
        {day:'02-15-2003',title:'Kreis 5',count:0},
        {day:'02-16-2004',title:'Kreis 6',count:380},
        {day:'02-17-2005',title:'Kreis 7',count:100},
        {day:'02-18-2006',title:'Kreis 8',count:300},
        {day:'02-16-2007',title:'Kreis 6',count:380},
        {day:'02-17-2008',title:'Kreis 7',count:100},
        {day:'02-18-2009',title:'Kreis 8',count:300}
      ]
    }

    this.changeCitizenship = this.changeCitizenship.bind(this);
    this.changeChosenQuarter = this.changeChosenQuarter.bind(this);


  }



  changeChosenQuarter(newChoice) {
    this.setState({
      chosenQuarter: newChoice
    });
  }

  changeCitizenship(quarter,choice,choiceIsMade) {
    this.setState({
      chosenQuarter: quarter,
      readerIsCityCitizen: choice,
      readerMadeHisChoice: choiceIsMade,
      showQuarterList: false
    });
    if(quarter) {
      this.setState({
        chosenQuarterName: quarter.name,
        chosenCircleName: quarter.circle,
        readerMadeHisChoice: true,
        readerIsCityCitizen: true
      })
    }

  }

  random = Math.random()*100000;

  render() {

    return (

      <div
        className='index'
      >





        {/*{this.state.readerMadeHisChoice &&*/}
          <SVGQuarterMap
            dataSource={this.state.dataSource}
            mapId='zh-quarter-map'
            mapTitle='Bodenpreise in den Zürcher Quartieren'
            mapLead='Klicken Sie auf die Karte, um die Preise pro Quadratmeter anzuzeigen'
            height={640}
            width={640}
            mapSource={zhQuarterMap}
            mapData={zhQuarterMapData}
            mapDataYear={2014}
            readerIsCityCitizen={this.state.readerIsCityCitizen}
            readerMadeHisChoice={this.state.readerMadeHisChoice}
            sortProp='QuartSort'
          />




        



      </div>

    );
  }
}

AppComponent.defaultProps = {};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/main/Main.js